(function () {
    'use strict';

    angular
        .module('app')
        .factory('userSettingsService', userSettingsService);

    userSettingsService.$inject = ['$http', '$q', '$localStorage'];

    function userSettingsService($http, $q, $localStorage) {
        var localStorage = $localStorage;

        var service = {
            //getVLBasePath: getVLBasePath,
            //setVLBasePath: setVLBasePath,
            processing: false
        };

        return service;

        //function getVLBasePath() {
        //    service.processing = true;
        //    var deferred = $q.defer();
        //    $http.get('../Synergis.WebApi/api/account/VLBasePath/').then(function (response) {
        //        service.vlBasePath = response.data;
        //        service.processing = false;
        //        deferred.resolve(response.data);
        //    });
        //    return deferred.promise;
        //}

        //function setVLBasePath(vlBasePath) {
        //    service.loading = true;
        //    var deferred = $q.defer();
        //    var request = $http({
        //        url: '../Synergis.WebApi/api/account/VLBasePath/',
        //        method: 'PUT',
        //        data: JSON.stringify(vlBasePath),
        //        headers: {
        //            "Content-Type": "application/json"
        //        }
        //    });
        //    request.then(function (response) {
        //        service.vlBasePath = response.data;
        //        service.loading = false;
        //        deferred.resolve(response);
        //    }, function (response) {
        //        service.loading = false;
        //        deferred.reject(response);
        //    });
        //    return deferred.promise;
        //}

        //getVLBasePath();

    }
})();